import graphql from "babel-plugin-relay/macro";

export const locationsDropdown = graphql`
fragment LocationFragments_LocationDropdown on Location @relay(plural: true) {
    id
    addressLine1
    addressLine2
    city
    state
    postalCode
    applicableVersion {
        name
    }
}`